import { AppMetadataHandler } from '../../../BaseFramework/configs/app-metadata.handler';
import { Component, OnInit, Input, Output, EventEmitter, ViewContainerRef } from '@angular/core';
import { NzNotificationService } from 'ng-zorro-antd/notification';
import { environment } from 'environments/environment';
import { TranslateService } from '@ngx-translate/core';
import { Router, ActivatedRoute } from '@angular/router';
import { WorkqueueService } from '../../../BaseFramework/core/http/workqueue.service';
import { ErrorDO } from '../../../BaseFramework/shared/models/error.model';


import {
  ValidationUtilService,
  ApiRequestService,
  LookupDataService,
  CommonUtilty,
  I18nService,
  MultiLingualService,
  InteractService,
  ComponentOutputDO

} from 'app'
import { AbstractControl, FormBuilder, FormControl, FormGroup, FormArray, Validators } from '@angular/forms';
import * as moment from 'moment/moment';


interface ValidationOutput {
  isInvalid: boolean,
  errorDOs: Array<ErrorDO>
}


@Component({
  selector: 'app-underwriting-decision',
  templateUrl: './underwriting-decision.component.html',
  styleUrls: ['./underwriting-decision.component.scss']
})
export class UnderwritingDecisionComponent implements OnInit {
  _currentComponentName = 'UnderwritingDecisionComponent'
  constructor(private viewContainerRef: ViewContainerRef,
    private validationUtilService: ValidationUtilService,
    private apiRequestService: ApiRequestService,
    private route: ActivatedRoute,
    private router: Router,
    private fb: FormBuilder,
    private commonUtilty: CommonUtilty,
    private i18nService: I18nService,
    private multiLingualService: MultiLingualService,
    private translateService: TranslateService,
    private lookupDataService: LookupDataService,
    private interactService: InteractService,
    private workQueueService: WorkqueueService,
    public appMetadataHandler: AppMetadataHandler
  ) { }

  //Declaraions which might need developer input
  underwritingDecisionForm: FormGroup
  UNDERWRITINGDECISIONFORM = "underwritingDecisionForm"
  selectorOfThisComponent = 'app-underwriting-decision'
  parentEvent$


  @Output() componentOutput = new EventEmitter<any>();
  @Output() selectedDecisionCd = new EventEmitter<any>();
  @Input() type: string;
  @Input() DO: any;
  @Input() DOName: any;
  @Input() transactionState: any;

  rulesData: any = [];

  private _inputDataForEdit = null;
  @Input()
  set inputDataForEdit(value: any) {
    this._inputDataForEdit = value;
    if (this._inputDataForEdit && this._inputDataForEdit['autoAdjResults'])
      this.rulesData = this._inputDataForEdit.autoAdjResults;
  };

  get inputDataForEdit() {
    return this._inputDataForEdit;
  }

  EmitComponentOutput(data) {
    let c = new ComponentOutputDO(this.getCurrentComponentName(), data, this.componentOutput)
    console.log("claims decision emitted data", c);
  }
  getParentComponent(): Component {
    try {
      return this.viewContainerRef['_data'].componentView.component.viewContainerRef['_view'].component
    } catch { }
  }
  getParentComponentName(): string {
    try {
      return this.viewContainerRef['_data'].componentView.component.viewContainerRef['_view'].component.constructor.name
    } catch { }
  }
  getCurrentComponentName(): string {
    return this._currentComponentName
  }

  subscribeToParentEvent() {
    if (this.parentEvent$ != null)
      this.parentEvent$.unsubscribe()
    this.parentEvent$ = this.interactService.pingSubject$.subscribe((param: any) => {
      const matches = param.filter(s => s.includes(this.getCurrentComponentName()));
      if (this.commonUtilty.isArrayIterable(param) && this.commonUtilty.isArrayIterable(matches)) {
        let validationResult = this.validateOutput(this.underwritingDecisionForm)
        if (!validationResult.isInvalid)
          this.EmitComponentOutput(this.underwritingDecisionForm)
        else {
          this.EmitComponentOutput(validationResult)
        }
      }
      else {
        console.warn(`${this.getCurrentComponentName()} recieved the ping, but is not a emitter child for current transaction type.`)
      }
    })
  }

  updateDecisionSelect() {
    let value = this.underwritingDecisionForm.get('underwritingDecision').value
    this.selectedDecisionCd.emit(value)
  }

  validateOutput(o) {
    this.commonUtilty.markAllFieldDirty(o);


    let validationOutput: ValidationOutput = {
      isInvalid: null,
      errorDOs: []
    }

    validationOutput.errorDOs = this.checkInvalidAndEmptyFields(o, this.getCurrentComponentName())
    if (Array.isArray(validationOutput.errorDOs) && validationOutput.errorDOs.length > 0) {
      validationOutput.isInvalid = true;
    }
    else {
      validationOutput.isInvalid = false;
    }

    return validationOutput



  }

  ngOnInit() {
    const consoleStyle = 'color: red; padding: 2px 5px; border-radius: 2px'
    if (environment && !environment.production) {
      console.group('%cClaims Basic Details : Usage detected on ' + this.getParentComponentName(), 'color: white; background-color: orange; padding: 2px 5px; border-radius: 2px');
      console.log(`%c<${this.selectorOfThisComponent}></${this.selectorOfThisComponent}>, has been used. `, consoleStyle)
      console.log("%cYou can override default title, message and icon(ng-zorro icon name).", consoleStyle)
      console.log(`%cExample , <${this.selectorOfThisComponent} (componentOutput)='doSomethingOnDataReceived()'></${this.selectorOfThisComponent}>`, consoleStyle)
      console.groupEnd();
    }

    if (this.inputDataForEdit != null) this.initializeUnderwritingDecisionForm(this.inputDataForEdit)
    this.subscribeToParentEvent()
  }



  /**
   * Form Trasactions
   */

  initializeUnderwritingDecisionForm(data?) {
    let payload = data || {}
    this.underwritingDecisionForm = this.fb.group({

      underwritingDecision: this.validationUtilService.setValidationsForFormControl('underwritingDecision', this.UNDERWRITINGDECISIONFORM, payload[this.DOName]['uwDecisionCd']),
      underwritingRemarks: this.validationUtilService.setValidationsForFormControl('underwritingRemarks', this.UNDERWRITINGDECISIONFORM, payload['uwDecisionValue']),

    });
  }

  lookupsToBind = ['manualAdjDecisionCd', 'decisionCd', 'manualUwDecisionCd','uwDecisionCd']
  lookup$ = this.commonUtilty.initializeLookupList(this.lookupsToBind)

  isRequired(fieldName, formName?) {
    let nameOfForm = null
    if (formName) {
      nameOfForm = formName
    }
    else {
      nameOfForm = this.UNDERWRITINGDECISIONFORM
    }
    let returnObj = this.validationUtilService.isRequired(fieldName, nameOfForm)
    return returnObj
  }



  public checkInvalidAndEmptyFields(Form: FormGroup, componentName) {
    let invalidFields = [];
    if (!Form.valid) {
      for (const i in Form.controls) {

        let controlName = this.commonUtilty.getControlName(Form.controls[i])
        let validationErrorList = this.validationUtilService.getUIErrorList(this.underwritingDecisionForm.get(controlName), this.UNDERWRITINGDECISIONFORM)
        if (Form.controls[i].status === 'INVALID') {
          validationErrorList.forEach(validationError => {
            let errorDO = new ErrorDO();
            errorDO.errorMsg = validationError;
            errorDO.fieldName = controlName;
            errorDO.fieldNameDescription = this.FormFieldNameMap[controlName]
            errorDO.componentName = componentName;
            invalidFields.push(errorDO)
          })
        }
      }
    }
    return invalidFields;
  }

  FormFieldNameMap = {
    eventType: "Event Type",
    eventDate: "Event Date",
  }


}


